// src/components/Dashboard/EnviosTimeline.js
import React from 'react';
import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
} from '@mui/material';

export default function EnviosTimeline({ envios = [], isAdmin = false, onSelect, loading }) {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!envios || envios.length === 0) {
    return (
      <>
        <Divider sx={{ my: 3 }} />
        <Typography variant="body1" color="text.secondary">
          No hay envíos disponibles.
        </Typography>
      </>
    );
  }

  const formatPeso = (p) => {
    if (p === null || typeof p === 'undefined' || Number.isNaN(Number(p))) return 'N/D';
    return `${Number(p).toLocaleString(undefined, { maximumFractionDigits: 2 })} lb`;
  };

  return (
    <>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6">
        {isAdmin ? '📦 Todos los envíos' : '📦 Mis envíos'}
      </Typography>

      <List>
        {envios.map((envio) => (
          <ListItem
            key={envio.id || envio.numeroGuia}
            button={!!onSelect}
            onClick={() => onSelect && onSelect(envio.id)}
            alignItems="flex-start"
          >
            <ListItemText
              primary={`Guía: ${envio.numeroGuia} | Estado: ${envio.estado}`}
              secondary={
                <>
                  <Typography component="span" variant="body2" color="text.primary">
                    {`Origen: ${envio.origen} → Destino: ${envio.destino}`}
                  </Typography>
                  <br />
                  <Typography component="span" variant="body2" color="text.secondary">
                    {`Tipo: ${envio.tipoEnvio} • Peso: ${formatPeso(envio.pesoLibras)}`}
                  </Typography>
                </>
              }
            />
          </ListItem>
        ))}
      </List>
    </>
  );
}